import {applyMiddleware, createStore} from 'redux';
import thunkMiddleware from 'redux-thunk';
import reducer from './reducers';
//import { createLogger } from 'redux-logger';

//const loggerMiddleware = createLogger();

const store = createStore(
  reducer,
  applyMiddleware(
    thunkMiddleware,
//    loggerMiddleware
  )
);

export default store;



// WEBPACK FOOTER //
// ./web/js/stores/rootStore.js